"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPrinter = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconPrinter = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M19.5 3v4.5H21A1.5 1.5 0 0122.5 9v7.5A1.5 1.5 0 0121 18h-1.5v3a1.5 1.5 0 01-1.5 1.5H6A1.5 1.5 0 014.5 21v-3H3a1.5 1.5 0 01-1.5-1.5V9A1.5 1.5 0 013 7.5h1.5V3A1.5 1.5 0 016 1.5h12A1.5 1.5 0 0119.5 3zM18 13.5H6V21h12v-7.5zM16.5 18v1.5h-9V18h9zm0-3v1.5h-9V15h9zM18 9h-3v1.5h3V9zm0-6H6v4.5h12V3z"
}));
exports.IconPrinter = IconPrinter;
//# sourceMappingURL=IconPrinter.js.map